module.exports = __webpack_public_path__ + "img/icon-credits-missing.bf781088.svg";